import React, { useImperativeHandle, useState } from 'react';
import { Button, Modal } from 'antd';
import { connect } from 'react-redux';
import { TableProps } from 'antd/es/table';
import intl from 'react-intl-universal';

import EditCellTable, { IcustomColumnType } from '@/components/EditCellTable';

export interface ImodalTableRef {
  closeModalTable?: () => void;
  openModalTable?: () => void;
}

interface Iprops extends React.PropsWithChildren<{}> {
  myRef: any;
  title: string;
  showCustomFooter?: boolean;
  columns: IcustomColumnType<any>[];
  dataSource: Array<any>;
  loading?: boolean;
  cellTableProps?: Omit<TableProps<any>, 'columns' | 'dataSource' | 'loading'>;
  onOk?: (value?: any) => Promise<any>;
  onCancel?: () => void;
  onSaveCell?: (value: any, index: number) => void;
}

const ModalTable: React.FC<Iprops> = ({
  children,
  myRef,
  title,
  showCustomFooter,
  columns,
  dataSource,
  loading,
  cellTableProps,
  onOk,
  onCancel,
  onSaveCell,
  ...rest
}) => {
  const [visible, setVisible] = useState(false);
  const closeModalTable = () => {
    setVisible(false);
  };
  const openModalTable = () => {
    setVisible(true);
  };
  const handleOk = () => {
    try {
      onOk?.().then(() => {
        setVisible(false);
      });
    } catch (error) {
      setVisible(false);
    }
  };
  const handleCancel = () => {
    setVisible(false);
    onCancel?.();
  };
  const handleSaveCell = (values, index) => {
    onSaveCell?.(values, index);
  };
  useImperativeHandle(
    myRef,
    () => ({
      closeModalTable,
      openModalTable,
    }),
    [],
  );
  return (
    <>
      <Modal
        title={title}
        destroyOnClose
        open={visible}
        footer={
          showCustomFooter ? (
            <Button type="primary" onClick={handleCancel}>
              {intl.get('app_confirm_close_btn')}
            </Button>
          ) : undefined
        }
        onOk={handleOk}
        onCancel={handleCancel}
        {...rest}
      >
        {children}
        <EditCellTable
          columns={columns}
          dataSource={dataSource}
          loading={loading}
          pagination={false}
          onSaveCellChange={handleSaveCell}
          {...cellTableProps}
        />
      </Modal>
    </>
  );
};

const mapStateToProps = () => {
  return {};
};

const ConnectComponent: React.FC<any> = connect(mapStateToProps, {})(React.memo(ModalTable));

export default React.forwardRef<ImodalTableRef, any>((props, ref) => (
  <ConnectComponent {...props} myRef={ref} />
));
